module.exports = __webpack_public_path__ + "img/empty-folder.00a8d458.svg";